import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from 'src/environments/environment';

/**
 * Pro-mode "Automation" tab API (workflow-definer /api/pro-automation). One GET/PUT for
 * the whole tab: the company persona, which lead sources feed the Default operation, and
 * the workflows (with routing examples) attached to the Default phase.
 */
@Injectable({ providedIn: 'root' })
export class ProAutomationService {
  private http = inject(HttpClient);
  private base = `${environment.apiBaseUrl}/api/pro-automation`;

  /** { persona, sources:[{id,source,sourceId,attached}], workflows:[{id,flowName,status,attached,example}] }. */
  get() { return this.http.get<any>(this.base); }

  /** { persona, sourceIds:[id], workflows:[{workflowId,workflowType,example}] }. */
  save(body: any) { return this.http.put<any>(this.base, body); }
}
